import { ethers } from 'ethers';
import { Network } from '../Networks/useNetworks';
import { Contracts } from '../../contracts/types';

export interface IState {
	isEthereum: boolean;
	isLoggedIn: boolean;
	isLoading: boolean;
	isMetaMask: boolean;
	isChainValid: boolean;
	account: string;
	chainId: Network;
	hasIssuedNetworkWarning: boolean;
	signer?: ethers.Signer;
	provider?: ethers.providers.Provider;
	contracts: {
		[p in Contracts]?: ethers.Contract;
	};
}

export const emptyState: IState = {
	isEthereum: false,
	isLoggedIn: false,
	isLoading: true,
	isMetaMask: false,
	isChainValid: false,
	/** Negative assertion as the state never goes true -> false otherwise than first-time initialised */
	hasIssuedNetworkWarning: true,
	account: ethers.constants.AddressZero,
	chainId: Network._,
	signer: undefined,
	provider: undefined,
	contracts: {
		igo: undefined,
		userProfile: undefined,
	},
};

export const Reducer = (state: IState, updatedProperties: Partial<IState>) => ({
	...state,
	...updatedProperties,
});
